var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-address c-address--add" }, [
    _c(
      "button",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.active,
            expression: "!active"
          }
        ],
        staticClass: "c-btn c-btn--primary c-btn--thin",
        class: { "u-margin-auto": !_vm.addressesSaved },
        on: { click: _vm.showForm }
      },
      [_vm._v("\n    + Add New Address\n  ")]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.active,
            expression: "active"
          }
        ],
        staticClass: "c-address-form"
      },
      [_vm._t("default")],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }